import client from '../base-api';

const serviceURL = '/office-audit';

const officeAuditService = {

    getOfficeList(filterData: any) {
        return client.get(`${serviceURL}/office-list`, {params: filterData});
    },
    getOfficeAuditList(officeId: number) {
        return client.get(`${serviceURL}/list/${officeId}`);
    },
    postOfficeAudit(auditData: any) {
        return client.post(`${serviceURL}`, auditData);
    },
    putOfficeAudit(auditData: any, auditId: number) {
        return client.put(`${serviceURL}/${auditId}`, auditData);
    },
    getOfficeAudit(auditId: number) {
        return client.get(`${serviceURL}/${auditId}`);
    },
    getOfficeAuditPreviousConcernAndSuggestions(officeId: number) {
        return client.get(`${serviceURL}/previous-concern-and-suggestion/${officeId}`);
    },

    // Calendar
    getMonthlyCalendar(filterData: any) {
        return client.get(`${serviceURL}/monthly-calendar`, {params: filterData});
    },
    getWeeklyCalendar(filterData: any) {
        return client.get(`${serviceURL}/weekly-calendar`, {params: filterData});
    },

}

export default officeAuditService;